import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { Title } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader, Attachments } from '@smartplatform/ui';
import { Editor } from '../../components';

let instance = null;

const AwardsInformation = () => {
	const [record, setRecord] = useState();

	const init = async () => {
		const data = await store.model.InformationAward.find()
			.then(res => {
				console.log(res);
				return res;
			})
			.catch(err => console.error('Got error', err));
		if (data.length > 0) {
			setRecord(data[0]);
		} else {
			setRecord(new store.model.InformationAward());
		}
	};
	const onUploadStart = files => {
	}
	const onUploadEnd = files => {
		if(instance) instance.reload();
	}
	useEffect(() => {
		init();
	}, []);

	if (!record) {
		return <Loader />;
	}

	console.log('record', record);
	return (
		<div>
			<Title record={record} name="Информация о наградах" />
			<Form record={record} rootPath="/admin" stay onSave={() => store.history.push(`/admin/awards-information`)}>
				<Field property="text" label="Текст информации о наградах">
					<Editor 
						filesUploadData={{
							record: record,
							relation: 'attachments',
							property: 'filename',
							onStart: onUploadStart,
							onEnd: onUploadEnd,
						}}
					/>
				</Field>

				{record.id ? (
					<Field label="Документы">
						<Attachments
							record={record}
							store={store.model}
							accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/zip, application/x-rar-compressed"
							instance={inst => instance = inst}
						/>
					</Field>
				) : (
					<p>Создайте для добавления документов </p>
				)}
			</Form>
		</div>
	);
};

export default withRouter(AwardsInformation);
